const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface21326410"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 21 50 L 21 55.792969 L 29.289062 50 Z M 21 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 38 50 L 32.78125 50 L 21 58.230469 L 21 59 C 21.003906 60.230469 21.753906 61.332031 22.898438 61.785156 L 38 51.234375 Z M 38 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 38 53.675781 L 26.082031 62 L 38 62 Z M 38 53.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 21 36.207031 L 21 42 L 29.289062 42 Z M 21 36.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 45 44 L 63 44 L 63 48 L 45 48 C 44.734375 48 44.480469 48.105469 44.292969 48.292969 C 44.105469 48.480469 44 48.734375 44 49 L 44 62 L 40 62 L 40 49 C 40 48.734375 39.894531 48.480469 39.707031 48.292969 C 39.519531 48.105469 39.265625 48 39 48 L 21 48 L 21 44 L 39 44 C 39.265625 44 39.519531 43.894531 39.707031 43.707031 C 39.894531 43.519531 40 43.265625 40 43 L 40 30 L 44 30 L 44 43 C 44 43.265625 44.105469 43.519531 44.292969 43.707031 C 44.480469 43.894531 44.734375 44 45 44 Z M 45 44 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 38 38.324219 L 38 30 L 26.082031 30 Z M 38 38.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 46 53.675781 L 46 62 L 57.917969 62 Z M 46 53.675781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 63 42 L 63 36.207031 L 54.710938 42 Z M 63 42 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 63 59 L 63 58.230469 L 51.21875 50 L 46 50 L 46 51.234375 L 61.101562 61.785156 C 62.246094 61.332031 62.996094 60.230469 63 59 Z M 63 59 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 38 42 L 32.78125 42 L 21 33.769531 L 21 33 C 21.003906 31.769531 21.753906 30.667969 22.898438 30.214844 L 38 40.765625 Z M 38 42 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 63 33 L 63 33.769531 L 51.21875 42 L 46 42 L 46 40.765625 L 61.101562 30.214844 C 62.246094 30.667969 62.996094 31.769531 63 33 Z M 63 33 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 63 55.792969 L 63 50 L 54.710938 50 Z M 63 55.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 46 38.324219 L 57.917969 30 L 46 30 Z M 46 38.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49 10 L 48 10 L 48 5 C 48 3.34375 46.65625 2 45 2 L 4 2 C 2.34375 2 1 3.34375 1 5 L 1 33 C 1 34.65625 2.34375 36 4 36 L 9 36 L 9 43 C 9 43.550781 9.449219 44 10 44 L 30.699219 44 L 42.445312 51.832031 C 42.753906 52.035156 43.148438 52.054688 43.472656 51.882812 C 43.796875 51.707031 44 51.367188 44 51 L 44 44 L 49 44 C 50.65625 44 52 42.65625 52 41 L 52 13 C 52 11.34375 50.65625 10 49 10 Z M 10 34 L 4 34 C 3.449219 34 3 33.550781 3 33 L 3 5 C 3 4.449219 3.449219 4 4 4 L 45 4 C 45.550781 4 46 4.449219 46 5 L 46 33 C 46 33.550781 45.550781 34 45 34 L 22 34 C 21.800781 34 21.609375 34.058594 21.445312 34.167969 L 11 41.132812 L 11 35 C 11 34.734375 10.894531 34.480469 10.707031 34.292969 C 10.519531 34.105469 10.265625 34 10 34 Z M 50 41 C 50 41.550781 49.550781 42 49 42 L 43 42 C 42.734375 42 42.480469 42.105469 42.292969 42.292969 C 42.105469 42.480469 42 42.734375 42 43 L 42 49.132812 L 31.554688 42.167969 C 31.390625 42.058594 31.199219 42 31 42 L 13.300781 42 L 22.300781 36 L 45 36 C 46.65625 36 48 34.65625 48 33 L 48 12 L 49 12 C 49.550781 12 50 12.449219 50 13 Z M 50 41 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.105469 31 C 24.371094 31 24.625 30.894531 24.8125 30.707031 C 25 30.519531 25.105469 30.265625 25.105469 30 L 25.105469 11.25 L 38.128906 30.105469 C 38.429688 30.617188 39.035156 30.859375 39.605469 30.699219 C 40.203125 30.476562 40.578125 29.882812 40.523438 29.25 L 40.316406 7.988281 C 40.3125 7.441406 39.867188 7 39.316406 7 L 39.308594 7 C 39.042969 7.003906 38.789062 7.109375 38.601562 7.300781 C 38.417969 7.488281 38.316406 7.746094 38.316406 8.011719 L 38.5 27.125 L 24.929688 7.472656 C 24.679688 7.113281 24.226562 6.957031 23.808594 7.085938 C 23.390625 7.214844 23.105469 7.601562 23.105469 8.042969 L 23.105469 30 C 23.105469 30.265625 23.210938 30.519531 23.398438 30.707031 C 23.585938 30.894531 23.839844 31 24.105469 31 Z M 24.105469 31 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.664062 29.898438 C 19.664062 29.632812 19.558594 29.378906 19.371094 29.191406 C 19.183594 29.003906 18.929688 28.898438 18.664062 28.898438 L 10.476562 28.898438 L 10.476562 20 L 17.984375 20 C 18.539062 20 18.984375 19.550781 18.984375 19 C 18.984375 18.449219 18.539062 18 17.984375 18 L 10.476562 18 L 10.476562 9.101562 L 18.664062 9.101562 C 19.214844 9.101562 19.664062 8.652344 19.664062 8.101562 C 19.664062 7.546875 19.214844 7.101562 18.664062 7.101562 L 9.476562 7.101562 C 9.210938 7.101562 8.957031 7.207031 8.769531 7.394531 C 8.582031 7.582031 8.476562 7.835938 8.476562 8.101562 L 8.476562 29.898438 C 8.476562 30.164062 8.582031 30.417969 8.769531 30.605469 C 8.957031 30.792969 9.210938 30.898438 9.476562 30.898438 L 18.664062 30.898438 C 18.929688 30.898438 19.183594 30.792969 19.371094 30.605469 C 19.558594 30.417969 19.664062 30.164062 19.664062 29.898438 Z M 19.664062 29.898438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.ced03d588f67048b5af3a06956767ac2.svg";
export { ForwardRef as ReactComponent };